import FastClick from 'fastclick';
import jQuery from 'jquery';
import angular from 'angular';

/* @ngInject */
export default function bootstrapApp($rootScope, $timeout, $window, $location, $route, SleuthService, CacheService, NotifyingService, APP_ROUTES) {
    $rootScope.$on('$routeChangeSuccess', function (event, current) {
        $rootScope.title = current.$$route.title;
    });

    $rootScope.$on('$routeChangeStart', function ($event, next, current) {
        // check if we're navigating away from home, if we are, remove the error.
        // theoretically, Angular _should_ remove this automatically on route change, but this is safety.
        if (current && current.$$route.name === APP_ROUTES.HOME.name) {
            $location.search('error', null);
        }
    });

    $rootScope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    $rootScope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    NotifyingService.subscribeToRootDefinitionChanges($rootScope, function () {
        $rootScope.removeSleuthData();
        $rootScope.clearSearchBar();
    });

    $rootScope.$on('$viewContentLoaded', function () {
        $timeout(function () {
            const windowWidth = window.innerWidth;

            if (windowWidth <= 768) {
                document.getElementsByTagName('main')[0].style.marginTop = document.getElementById('masthead').offsetHeight + 'px';
            } else {
                document.getElementsByTagName('main')[0].style.marginTop = '';
            }
        }, 0);
    });

    const updateMainMarginTop = function () {
        const windowWidth = window.innerWidth;

        if (document.getElementsByTagName('main')[0]) { // In case internet is slow and didn't set style.
            if (windowWidth <= 992) {
                document.getElementsByTagName('main')[0].style.marginTop = document.getElementById('masthead').offsetHeight + 'px';
            } else {
                document.getElementsByTagName('main')[0].style.marginTop = '';
            }
        }
    };

    //Fast Click
    if ('addEventListener' in document) {
        document.addEventListener('DOMContentLoaded', function () {
            FastClick.attach(document.body);
        }, false);
    }
    //End Fast Click

    if (window.addEventListener) {
        window.addEventListener('resize', updateMainMarginTop);
    } else {
        window.attachEvent('resize', updateMainMarginTop);
    }

    jQuery('#masthead').resize(updateMainMarginTop);
    updateMainMarginTop();

    //Menu handling
    jQuery('.menu').click(function () {
        const el = jQuery(this).data('target');
        if (jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            // If we don't remove the style attribute on completion
            // the desktop version of the navigation isn't shown.
            jQuery(el).hide('fast', function () {
                jQuery(this).removeAttr('style');
            });
        } else {
            jQuery(this).addClass('active');
            jQuery(el).show('slow');
        }
    });

    // Google Analytics
    if ($window.ga) {
        $window.ga('create', 'UA-172231-10', 'auto');
        $window.ga('create', 'UA-172231-1', 'auto', 'marketingCETracker');
    }

    $rootScope.$on('$routeChangeSuccess', function () {
        if ($window.ga) {
            $window.ga('send', {
                'hitType': 'pageview',
                'page': $location.path()
            });
            $window.ga('marketingCETracker.send', {
                'hitType': 'pageview',
                'page': $location.path()
            });
        }
    });

    //IE Garbage
    const doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);

    function testBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();

        const goodBrowser = ((userAgent.indexOf('chrome') > -1) ||
            (userAgent.indexOf('firefox') > -1) ||
            (userAgent.indexOf('opera') > -1) ||
            (userAgent.indexOf('safari') > -1)
        );

        if (!goodBrowser) {
            jQuery('#overlyUniqueIdentifierForModalWrapper').modal({backdrop: false, keyboard: false});
        }
    }

    //testBrowser();
}

export function loadBindings() {
    const isPlaceholderSupported = (function () {
        const i = document.createElement('input');
        return 'placeholder' in i;
    });

    if (!isPlaceholderSupported) {
        const searchBox = document.getElementById('search-box');
        const placeholder = angular.element(searchBox).attr('placeholder');
        angular.element(searchBox).val(placeholder);

        /*
        In IE versions less than 9, addEventListener doesn't work. Use attachEvent instead:
        https://msdn.microsoft.com/en-us/library/ms536343%28VS.85%29.aspx
         */
        if (searchBox.addEventListener) {
            searchBox.addEventListener('click', function () {
                this.value = '';
            });

            searchBox.addEventListener('blur', function () {
                this.value = placeholder;
            });
        } else {
            searchBox.attachEvent('onclick', function () {
                this.value = '';
            });

            searchBox.attachEvent('onclick', function () {
                this.value = placeholder;
            });
        }
    }

    const modalWrapper = document.getElementById('overlyUniqueIdentifierForModalWrapper');
    const closeBtn = document.getElementById('ie7-modal');
    const confBtn = document.getElementById('btn-confirm');

    function hideModal() {
        modalWrapper.style.display = 'none';
    }

    if (closeBtn && confBtn) {
        jQuery('#ie7-modal').on('click', hideModal);
        jQuery('#btn-confirm').on('click', hideModal);
    }
}
